import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'g10-route-holiday-view',
  templateUrl: './route-holiday-view.component.html',
  styleUrls: ['./route-holiday-view.component.css']
})
export class RouteHolidayViewComponent implements OnInit {

  @Input() popup = true;
  @Input() modalTitle = 'Route Holiday View';
  @Input() data:any;
  @Output() closeEvent = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
    console.log(this.data);
  }

  closePopup() {
    this.closeEvent.emit(true);
  }

}
